module.exports = "<div id=\"fullscreen\" class=\"btn-header transparent pull-right\">\n        <span> <a (click)=\"onToggle()\" title=\"Phóng lớn toàn màn hình\"><i\n                class=\"fa fa-arrows-alt\"></i></a> </span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/header/full-screen/full-screen.component.html
// module id = ./src/app/shared/layout/header/full-screen/full-screen.component.html
// module chunks = main